import { Fragment, useContext, useEffect, useMemo, useRef, useState } from "react";
import { UBButton, ParagraphText } from "../../../../Libraries";
import { TitleAndActionBox } from "../../../common";
import { Box, CircularProgress, Grid } from "@mui/material";
import { LanguageContext } from "../../../../context/LanguageContext";
import formStyles from "../../SaleExpense/SaleExpenseForm/styles.module.css";
import elStyles from "./Easyload.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import {
  TelenoreImageNew,
  UfoneImageNew,
  ZongImageNew,
  JazzImageNew,
} from "../../../../assets/images";
import ReviewSection from "./ReviewSection";
import RechargeFormSection from "./RechargeFormSection";
import { useWalletContext } from "../../../../context/WalletContext";
import { EasyloadAndPackages, uuid } from "../../../../constants";
import { useAuthContext } from "../../../../context/AuthContext";
import { useSnackbar } from "../../../../context/SnackbarContext";
import { Sync } from "../../../../SyncService";
import { handleApi } from "../../../../apis";
import {
  WALLETRECHARGE,
  WALLETRECHARGETRANSACTION,
} from "../../../../apis/configuration";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import withObservables from "@nozbe/with-observables";
import { getCustomerOfBusiness } from "../../../../database/helpers/customer";
import { EnterIcon } from "../../../../assets/icons/icon";
import { getCategoriesByType } from "../../../../utils";
import AmountSection from "./AmountSection";
import { v4 as uuidv4 } from "uuid";
import BusinessLoader from "../../../common/BusinessLoader";
import AddCustomerModal from "../../../common/Modals/AddCustomerModal";
import VerifyPinModal from "../../../common/Modals/VerifyPinModal";
import { phoneNumRegex } from "../../../../validations";

const options = {
  Jazz: { image: JazzImageNew, imageClass: "jazzImage", alt: "Jazz" },
  Zong: { image: ZongImageNew, imageClass: "zongImage", alt: "Zong" },
  Telenor: {
    image: TelenoreImageNew,
    imageClass: "telenorImage",
    alt: "Telenor",
  },
  Ufone: { image: UfoneImageNew, imageClass: "ufoneImage", alt: "Ufone" },
};

const amountChipIndex = {
  100: 0,
  200: 1,
  500: 2,
  1000: 3,
};

const phoneOptions = [{ label: "Prepaid" }, { label: "Postpaid" }];

const Easyload = ({ customers }) => {
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [showReview, setShowReview] = useState(false);
  const [showAddCustomerModal, setShowAddCustomerModal] = useState(false);
  const [isVerifyOpen, setIsVerifyOpen] = useState(false);
  const verifyCustomerOverrideRef = useRef(undefined);
  const [contactError, setContactError] = useState("");
  const [selectedLoad, setSelectedLoad] = useState(
    EasyloadAndPackages.EASYLOAD,
  );
  const [bundleTypes, setBundleTypes] = useState([]);
  const [bundles, setBundles] = useState([]);
  const [amountPage, setAmountPage] = useState(false);
  const [state, setState] = useState({
    platform: "",
    customerNumber: "",
    amount: "",
    customerName: "",
    offer: null,
    paymentStatus: "Paid",
    rechargeCategory: "",
    rechargeCategoryId: "",
    paymentMode: "Bank",

  });
  const [customer, setCustomer] = useState();
  const [chipActiveIndex, setChipActiveIndex] = useState(null);
  const [networkTypeValue, setNetworkTypeValue] = useState(phoneOptions[0].label);
  const [error, setError] = useState("");
  const [mobileNetwork, setMobileNetwork] = useState([]);
  const [selectedTelco, setSelectedTelco] = useState();
  const [amountError, setAmountError] = useState("");
  const [isDisabledEasyLoad, setDisabledEasyLoad] = useState(false);
  const [isDisabledPackage, setDisabledPackage] = useState(false);
  const [isShowOnlyTelco, setShowOnlyTelco] = useState(false);
  const { fetchWalletData, earnMoney, walletData } = useWalletContext();
  const balance = walletData?.current_balance || 0;
  const availableTelcos = walletData?.available_telcos || [];
  const idempotencyKey = useRef(uuidv4());
  const lastSubmittedRef = useRef({
    customerNumber: "",
    platform: "",
    amount: "",
    customerName: "",
    offerKey: "",
    billingType: "",
    categoryId: "",
  });

  const { business, user } = useAuthContext();
  const { showSnackbar } = useSnackbar();
  const network = location.state?.network;
  const customerPhone = location.state?.customerPhone;
  const customerName = location.state?.customerName;
  const tab = location.state?.tab;
  useEffect(() => {
    if (network?.name || tab) handleClick("", { alt: network?.name || tab?.toLowerCase() });
    if (customerPhone) {
      setState((e) => ({
        ...e,
        customerName: customerName || "",
        customerNumber: customerPhone || "",
      }));
    }
  }, [network, tab])

  useEffect(() => {
    if (earnMoney?.easyloadPackages?.list?.length > 0) {
      const list = earnMoney?.easyloadPackages?.list.map((item) => {
        return { ...options[item.name], active: item.active };
      });
      setMobileNetwork(list);
    }
  }, [earnMoney?.easyloadPackages]);

  useEffect(() => {
    if (contactError) setContactError("");
  }, [state.customerNumber]);

  const validateContactNumber = () => {
    const number = state.customerNumber || "";
    if (!number) return true;
    if (number.length !== 11) {
      setContactError(I18n.phone_number_length);
      return false;
    }
    if (number.match(phoneNumRegex) === null) {
      setContactError(I18n.phone_number_format);
      return false;
    }
    return true;
  };

  const onContinue = () => {
    if (!validateContactNumber()) return;
    if (balance < state?.amount) {
      showSnackbar({
        message: I18n.insufficient_balance_please_try_different_amount,
        severity: "error",
        icon: "",
      });
      return;
    }
    triggerLogEvent(
      analytics,
      selectedLoad === EasyloadAndPackages.EASYLOAD
        ? "w_earn_ep_easyload_continue"
        : "w_earn_ep_packages_continue",
    );
    setShowReview(true);
  };
  let timeoutId = null;

  const handleRecharge = async (customerOverride) => {
    const effectiveCustomer = customerOverride !== undefined ? customerOverride : customer;
    triggerLogEvent(
      analytics,
      selectedLoad === EasyloadAndPackages.EASYLOAD
        ? "w_earn_ep_easyload_recharge"
        : "w_earn_ep_packages_recharge",
    );
    setIsLoading(true);
    try {
      const currentSubmission = {
        customerNumber: state?.customerNumber || "",
        platform: state?.platform || "",
        amount: +state?.amount || 0,
        customerName: state?.customerName || "",
        offerKey: state?.offer?.offer_key || "",
        billingType: networkTypeValue.toLocaleLowerCase(),
        categoryId: state.rechargeCategoryId || "",
      };
      // Only mint a new idempotency key if the payload changed since the last attempt,
      // so retries of the same request stay idempotent.
      if (
        Object.keys(currentSubmission).some(
          (key) => currentSubmission[key] !== lastSubmittedRef.current[key],
        )
      ) {
        idempotencyKey.current = uuidv4();
      }
      lastSubmittedRef.current = currentSubmission;
      const payload = {
        customer_msisdn: state?.customerNumber,
        platform_uid: state?.platform,
        amount: +state?.amount,
        business_id: business?.id,
        customer_name: state?.customerName,
        offer_key: state?.offer?.offer_key || undefined,
        billing_type: networkTypeValue.toLocaleLowerCase(),
        idempotency_key: idempotencyKey.current,
        category_id: state.rechargeCategoryId || "",
      };
      const response = await handleApi(
        WALLETRECHARGE,
        payload,
        undefined,
        navigate,
      );
      fetchWalletRechargeTransaction(response?.recharge_key, effectiveCustomer);
    } catch (error) {
      showSnackbar({
        message:
          error?.response?.data?.message || I18n.error_in_easyload_and_package,
        severity: "error",
        icon: "",
      });
      setIsLoading(false);
    }
  };

  const handleRechargeClick = () => {
    const isUnpaid = (state.paymentStatus || "").toLowerCase() === "unpaid";
    if (isUnpaid && !customer?.name) {
      setShowAddCustomerModal(true);
      return;
    }
    verifyCustomerOverrideRef.current = undefined;
    setIsVerifyOpen(true);
  };

  const handleAddCustomerSaved = (payload) => {
    const c = (customers || []).find((x) => x.id === payload?.id);
    const resolvedCustomer = c ?? payload;
    setCustomer(resolvedCustomer);
    setState((e) => ({
      ...e,
      customerName: payload?.name || "",
      customerNumber: payload?.phone || e.customerNumber,
    }));
    setShowAddCustomerModal(false);
    verifyCustomerOverrideRef.current = resolvedCustomer;
    setIsVerifyOpen(true);
  };

  const handleVerifiedRecharge = () => {
    handleRecharge(verifyCustomerOverrideRef.current);
  };

  const fetchWalletRechargeTransaction = async (id, customerOverride) => {
    const effectiveCustomer = customerOverride !== undefined ? customerOverride : customer;
    try {
      const response = await handleApi(
        WALLETRECHARGETRANSACTION,
        {
          recharge_key: id,
        },
        null,
        navigate,
      );
      if (response?.status === "COMPLETED") {
        const transaction = response?.transaction_details || {};
        let icon = (earnMoney?.easyloadPackages?.list || []).find(
          (item) =>
            item.name.toLowerCase() === transaction?.service?.toLowerCase(),
        );
        icon = icon?.logo;
        const data = {
          from: `${transaction?.sender_name
            }(****${transaction?.from_account?.slice(-4)})`,
          amount: Math.abs(transaction?.amount),
          to: `${transaction?.customer_name}(****${transaction?.customer.slice(
            -4,
          )})`,
          logo: icon,
          type: transaction?.type,
          date: transaction?.created_at,
          commission: transaction?.commission,
          offer_name: transaction?.offer_name,
        };
        if (state?.paymentStatus == "Unpaid" && effectiveCustomer) {
          let paramsForPayment = {
            uid: uuid(),
            amount: Number(state?.amount),
            payment_mode: "Udhaar",
            date: new Date(),
            udhaar_note: "Easyload",
            imageURL: null,
            outstanding:
              effectiveCustomer.total_outstanding_payment + Number(state?.amount),
            external_type: "easyload",
          };

          await effectiveCustomer.createPayment(paramsForPayment);
          Sync(user.phone_number, navigate);
        }
        if (timeoutId) {
          clearTimeout(timeoutId); // Clear the timeout if the request was successful
        }
        fetchWalletData();
        setIsLoading(false);
        triggerLogEvent(
          analytics,
          selectedLoad === EasyloadAndPackages.EASYLOAD
            ? "w_earn_ep_easyload_confirm"
            : "w_earn_ep_packages_confirm",
        );
        navigate(`/UCash/Easyload/TransactionSuccess/${id}`, {
          state: { data, transaction },
        });
      } else {
        setIsLoading(true);
        timeoutId = setTimeout(
          () => fetchWalletRechargeTransaction(id, customerOverride),
          5000,
        );
      }
    } catch (error) {
      showSnackbar({
        message: error?.response?.data?.message || I18n.error_in_recharge,
        severity: "error",
        icon: "",
      });
      setIsLoading(false);
    }
  };

  const manageData = (selectedBundle) => {
    let bundleObj = {};
    (selectedBundle || [])?.map((data) => {
      if (bundleObj[data.bundle_type]) {
        let arr = bundleObj[data.bundle_type];
        bundleObj[data.bundle_type] = [...arr, data];
      } else {
        bundleObj[data.bundle_type] = [data];
      }
    });

    setBundleTypes(Object.keys(bundleObj));
    setBundles(bundleObj);
  };

  const handleClick = (index, item) => {
    triggerLogEvent(analytics, "w_earn_ep_network");
    const networkObj = availableTelcos.find((i) => i.name.toLowerCase() == item.alt.toLowerCase());
    setDisabledEasyLoad(!networkObj?.recharge_active);
    setDisabledPackage(!networkObj?.bundle_active);
    if (selectedLoad === EasyloadAndPackages.EASYLOAD && !networkObj?.recharge_active ||
      selectedLoad === EasyloadAndPackages.PACKAGES && !networkObj?.bundle_active) {
      showSnackbar({
        message: I18n.network_service_currently_unavailable.replace(
          "{network}",
          networkObj?.name || item?.alt || "",
        ),
        severity: "error",
        icon: "",
      });
      return;
    }
    setSelectedLoad(selectedLoad || EasyloadAndPackages.EASYLOAD);
    manageData(networkObj?.bundles);
    setChipActiveIndex(null);
    setState((e) => ({
      ...e,
      platform: (item?.alt || "")?.toLowerCase(),
      offer: null,
      amount: "",
    }));
    setAmountError("");
    setSelectedTelco(networkObj);
  };

  const onChangeText = (key, text) => {
    setError("");
    setState({ ...state, [key]: text });
    if (key === "amount") {
      setChipActiveIndex(amountChipIndex[Number(text)] ?? null);
      if (state.amount.length === 0 && text.length === 1)
        triggerLogEvent(analytics, "w_earn_ep_easyload_amnt");
      if (!text) setAmountError("");
      if (
        selectedTelco.maximum_recharge >= text &&
        selectedTelco.minimum_recharge <= text
      )
        setAmountError("");
      else if (text)
        setAmountError(
          `Enter amount between ${selectedTelco.minimum_recharge} to ${selectedTelco.maximum_recharge}`,
        );
    }
  };

  const handleChip = (index, item) => {
    setChipActiveIndex(index, item);
    triggerLogEvent(analytics, "w_earn_ep_easyload_amnt_chips");
    setState({ ...state, amount: item.value });
    if (
      selectedTelco.maximum_recharge >= item.value &&
      selectedTelco.minimum_recharge <= item.value
    )
      setAmountError("");
    else
      setAmountError(
        `Enter amount between ${selectedTelco.minimum_recharge} to ${selectedTelco.maximum_recharge}`,
      );
  };
  const handlePhoneTag = (value) => {
    triggerLogEvent(
      analytics,
      value === phoneOptions[0].label
        ? "w_earn_ep_easyload_contact_pre"
        : "w_earn_ep_easyload_contact_post",
    );
    setNetworkTypeValue(value);
  };

  const categoryList = useMemo(() => getCategoriesByType("recharge"), []);

  const ChipOptions = [
    { label: "Rs. 100", value: 100 },
    { label: "Rs. 200", value: 200 },
    { label: "Rs. 500", value: 500 },
    { label: "Rs. 1000", value: 1000 },
  ];
  const isDisabled = !Boolean(
    (selectedLoad === EasyloadAndPackages.EASYLOAD
      ? selectedTelco?.maximum_recharge >= state.amount &&
      selectedTelco?.minimum_recharge <= state.amount
      : state.offer) &&
    state.platform &&
    state.customerNumber,
  );
  const isNextDisabled = !Boolean(
    (selectedLoad || state.offer) &&
    state.platform &&
    state.customerNumber,
  );

  const onNext = () => {
    if (!validateContactNumber()) return;
    triggerLogEvent(analytics, "w_earn_ep_easyload_next");
    setAmountPage(true);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        event.shiftKey &&
        event.key === "Enter" &&
        !(isDisabled || isLoading)
      ) {
        event.preventDefault();
        if (showReview) handleRechargeClick();
        else onContinue();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [showReview, isDisabled, isLoading, onContinue, handleRechargeClick]);

  const isHiddenTelcoAndContact = Boolean(network?.name)
  return (
    <Fragment>
      <BusinessLoader loadBusiness={isLoading} />
      <Grid
        container
        className={`${formStyles.root} ${formStyles.SaleExpenseFormWrapper} ${elStyles.easyloadWrapper}`}
      >
        <Grid item md={12}>
          <TitleAndActionBox
            data={{
              title: showReview
                ? I18n.confirm_payment
                : amountPage
                  ? I18n.enter_amount_trans
                  : I18n.easyload_packages,
              isBack: true,
              onBack: isLoading
                ? () => { }
                : showReview
                  ? () => {
                    setShowReview(false);
                  }
                  : amountPage ?
                    () => setAmountPage(false) :
                    () => navigate(-1),
              id: "easyload",
            }}
          />
          <Box className={formStyles.formBodyGrid}>
            <Box className={formStyles.formColumn}>
              <Box
                className={`${formStyles.formBody} expenseFormBody ${elStyles.easyloadFormBody}`}
              >
                {
                  showReview ?
                    <ReviewSection
                      I18n={I18n}
                      detail={{
                        ...state,
                        type: selectedLoad,
                        billType: networkTypeValue.toLocaleLowerCase(),
                      }}
                      categoryList={categoryList}
                      setState={setState}
                      state={state} />
                    :
                    amountPage ? (
                      <AmountSection
                        earnMoney={earnMoney}
                        I18n={I18n}
                        handleChip={handleChip}
                        ChipOptions={ChipOptions}
                        chipActiveIndex={chipActiveIndex}
                        onChangeText={onChangeText}
                        detail={{
                          ...state,
                          type: selectedLoad,
                          billType: networkTypeValue.toLocaleLowerCase(),
                        }}
                        onBack={() => { setAmountPage(false); if (isHiddenTelcoAndContact) setShowOnlyTelco(true) }}
                        customers={customers}
                        setCustomer={setCustomer}
                        selectedLoad={selectedLoad}
                        setState={setState}
                        isHiddenTelcoAndContact={isHiddenTelcoAndContact}
                        amountError={amountError}
                        isPackageSelected={selectedLoad === EasyloadAndPackages.PACKAGES}
                        contactError={contactError}
                      />
                    ) : (
                      <RechargeFormSection
                        I18n={I18n}
                        options={mobileNetwork}
                        handleClick={handleClick}
                        onChangeText={onChangeText}
                        state={state}
                        setState={setState}
                        contactError={contactError}
                        ChipOptions={ChipOptions}
                        handleChip={handleChip}
                        chipActiveIndex={chipActiveIndex}
                        phoneOptions={phoneOptions}
                        handlePhoneTag={handlePhoneTag}
                        networkTypeValue={networkTypeValue}
                        selectedLoad={selectedLoad}
                        isDisabledEasyLoad={isDisabledEasyLoad}
                        isDisabledPackage={isDisabledPackage}
                        setCustomer={setCustomer}
                        onNext={onNext}
                        setSelectedLoad={(value) => {
                          setChipActiveIndex(null);
                          setNetworkTypeValue(phoneOptions[0].label)
                          setState((e) => ({
                            ...e,
                            offer: null,
                            amount: "",
                            customerName: customerName || "",
                            customerNumber: customerPhone || "",
                          }));
                          setCustomer(undefined);
                          setAmountError("");
                          setSelectedLoad(value);
                          triggerLogEvent(
                            analytics,
                            value === EasyloadAndPackages.EASYLOAD
                              ? "w_earn_ep_easyload"
                              : "w_earn_ep_packages",
                          );
                        }}
                        bundleTypes={bundleTypes}
                        bundles={bundles}
                        amountError={amountError}
                        customers={customers}
                        isHiddenTelcoAndContact={isHiddenTelcoAndContact}
                        isShowOnlyTelco={isShowOnlyTelco}
                        isPackageSelected={selectedLoad === EasyloadAndPackages.PACKAGES}

                      />
                    )}
                {
                  showReview ?
                    <UBButton
                      id="easyload_primary_next_action"
                      title={<ParagraphText>{I18n.next}</ParagraphText>}
                      iconComponent={<EnterIcon />}
                      iconPlacement="right"
                      disabled={isDisabled}
                      className={`buttonPrimary saveSaleButton ${elStyles.easyloadPrimaryAction}`}
                      onClick={handleRechargeClick}
                    />
                    :
                    amountPage ?
                      <UBButton
                        id="easyload_primary_next_action"
                        title={<ParagraphText>{I18n.next}</ParagraphText>}
                        iconComponent={<EnterIcon />}
                        iconPlacement="right"
                        disabled={isDisabled}
                        className={`buttonPrimary saveSaleButton ${elStyles.easyloadPrimaryAction}`}
                        onClick={onContinue}
                      /> :
                      selectedLoad === EasyloadAndPackages.EASYLOAD &&
                      <UBButton
                        id="easyload_primary_next_action"
                        title={<ParagraphText>{I18n.next}</ParagraphText>}
                        iconComponent={<EnterIcon />}
                        iconPlacement="right"
                        disabled={isNextDisabled}
                        className={`buttonPrimary saveSaleButton ${elStyles.easyloadPrimaryAction}`}
                        onClick={onNext}

                      />
                }

              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <AddCustomerModal
        isOpen={showAddCustomerModal}
        handleClose={() => setShowAddCustomerModal(false)}
        navigate={navigate}
        initialName=""
        initialPhone={state.customerNumber}
        onSaveCallback={handleAddCustomerSaved}
        type="in"
        title={
          <ParagraphText className={"ms-1 textLowercase"}>
            {I18n.customer}
          </ParagraphText>
        }
        isTypeField={true}
        isOnlyPhoneList={true}
      />

      <VerifyPinModal
        open={isVerifyOpen}
        handleClose={() => setIsVerifyOpen(false)}
        amount={state.amount}
        onVerified={handleVerifiedRecharge}
        forgotPinAnalyticsEvent="w_earn_ep_forgot_pin"
      />
    </Fragment>
  );
};

const enhance = withObservables([], () => ({
  customers: getCustomerOfBusiness(
    typeof window !== "undefined"
      ? localStorage.getItem("business_id") || ""
      : "",
  ),
}));

export default enhance(Easyload);
